import {
  UI_COLOR_CHIP_INFO_BG,
  UI_COLOR_CHIP_INFO_TEXT,
  UI_COLOR_SUCCESS_SOFT,
  UI_COLOR_SUCCESS_TEXT
} from '../../../constants/uiColors'
import { rbacDetailsFieldSx } from './rbacDetailCardConstants'

export const rbacAssignedItemsSx = {
  ...rbacDetailsFieldSx,
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: 1,
  minHeight: 52
}

export const rbacAssignedUserChipSx = {
  backgroundColor: UI_COLOR_CHIP_INFO_BG,
  color: UI_COLOR_CHIP_INFO_TEXT,
  fontWeight: 700,
  maxWidth: '100%',
  '&&': {
    minWidth: '0 !important',
    height: 'auto !important',
    minHeight: 22,
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    py: '4px'
  }
}

export const rbacAssignedAllChipSx = {
  backgroundColor: UI_COLOR_SUCCESS_SOFT,
  color: UI_COLOR_SUCCESS_TEXT,
  maxWidth: '100%',
  '&&': {
    minWidth: '0 !important',
    height: 'auto !important',
    minHeight: 28,
    borderRadius: '8px',
    padding: '4px 16px',
    gap: 1,
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: 1.4,
    textTransform: 'none',
    whiteSpace: 'normal',
    overflowWrap: 'anywhere'
  },
  '& svg': { flexShrink: 0 }
}
